﻿/**
 * Checks if an object is "thenable" (Promise-like).
 * This checks for the presence of a then method, but doesn't guarantee
 * that the object follows the Promise A+ specification.
 *
 * @param obj The object to check
 * @returns True if the object is thenable
 */
export default function isPromiseAlike<T = unknown>(obj: unknown): obj is PromiseLike<T> {
	return obj !== null &&
		typeof obj === 'object' &&
		'then' in obj &&
		typeof (obj as any).then === 'function';
}
